import { useDispatch } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import PropTypes from "prop-types";
import AppLayout from "../../app_layout/AppLayout";
import Unauthorized from "../../pages/general/Unauthorized";
import React from "react";
import FullOverlaySpinner from "../../components/LoadingSpinner/FullOverlaySpinner";

function ProtectedRoute({ element }) {
  const dispatch = useDispatch();
  const { keycloak, initialized } = useKeycloak();

  if(!initialized)
  {
    return <AppLayout children={<FullOverlaySpinner show={!initialized}/>}/> ;
  }
  
  const isLoggedIn = keycloak.authenticated;
  
  return isLoggedIn ? <AppLayout children={element}/> : <AppLayout children={<Unauthorized/>}/>;
}

ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
};

export default ProtectedRoute;
